// src/ChapterSelection.js
// import React, { useState } from 'react';

const ChapterSelection = ({
  selectedSubject,
  selectedClass,
  selectedChapter,
  onChapterSelected,
}) => {
  const handleChapterChange = (event) => {
    const newSelectedChapter = event.target.value;
    onChapterSelected(newSelectedChapter); // Notify the parent component of the selected chapter
  };

  // You can replace this sample chapter data with your actual chapter data
  const chapterData = {
    Maths: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],

      // Add chapters for other classes here
    },
    Evs: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    English: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],

    },
    Grammar: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25, 26, 27, 28],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    },
    Hindi: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    Science: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    },
    Sst: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    },
    Computer: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      3: [1, 2, 3, 4, 5, 6, 7, 8],
      4: [1, 2, 3, 4, 5, 6, 7, 8],
      5: [1, 2, 3, 4, 5, 6, 7, 8],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    },
    Gk:{
      1: [1, 2, 3, 4, 5, 6, 7],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      4: [1, 2, 3, 4, 5, 6, 7, 8],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      8: [1, 2, 3, 4, 5, 6],
    },
    Vyakaran: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8],
      // class
      2: [1, 2, 3, 4, 5, 6],
      3: [1, 2, 3, 4, 5, 6],
      4: [1, 2, 3, 4, 5, 6],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      7: [1, 2, 3, 4, 5, 6],
      8: [1, 2, 3, 4, 5, 6],

      // Add chapters for other classes here
    },
  };

  const chapters = chapterData[selectedSubject]?.[selectedClass] || [];

  return (
    <div className="p-4 border rounded-md shadow-md">
      <h2 className="text-lg font-semibold mb-2">
        Select a Chapter for {selectedSubject}, {selectedClass}:
      </h2>
      <select
        className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:border-blue-500"
        onChange={handleChapterChange}
        value={selectedChapter}
      >
        <option value="">-- Select a Chapter --</option>
        {chapters.map((chapter) => (
          <option key={chapter} value={chapter}>
            {chapter}
          </option>
        ))}
      </select>
      <p className="mt-2">Selected Chapter: {selectedChapter}</p>
    </div>
  );
};

export default ChapterSelection;
